"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _lottery = require("@/api/activity/lottery");
var _index = require("@/utils/index");
var _ActivityQrcodeDialog = _interopRequireDefault(require("@/components/ActivityQrcodeDialog"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LotteryTablePane',
  components: {
    ActivityQrcodeDialog: _ActivityQrcodeDialog.default
  },
  data: function data() {
    return {
      searchForm: {
        keyword: ''
      },
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      qrcodeDialogVisible: false,
      currentLottery: {},
      qrItems: [],
      qrTitle: ''
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.tableLoading = true;
              _context.prev = 1;
              params = {
                page: this.currentPage,
                limit: this.pageSize,
                keyword: this.searchForm.keyword
              };
              _context.next = 2;
              return (0, _lottery.getLotteryList)(params);
            case 2:
              response = _context.sent;
              if (response.code === 200) {
                // 兼容两种返回格式：extra中有数据，或者直接在response中
                this.tableData = response.extra.records || [];
                this.total = response.extra.total || 0;
              } else {
                this.$message.error(response.message || '获取数据失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              this.$message.error('获取数据失败：' + _t.message);
            case 4:
              _context.prev = 4;
              this.tableLoading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }(),
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        keyword: ''
      };
      this.currentPage = 1;
      this.fetchData();
    },
    handleAdd: function handleAdd() {
      this.$emit('toLotteryConfig', null);
    },
    handleEdit: function handleEdit(row) {
      // 添加空值检查
      if (!row || !row.id) {
        this.$message.warning('无法编辑：数据异常');
        return;
      }
      // 传递完整的活动信息，包括id和title
      this.$emit('toLotteryConfig', {
        id: row.id,
        title: row.title
      });
    },
    handleRecord: function handleRecord(row) {
      // 添加空值检查
      if (!row || !row.id) {
        this.$message.warning('无法查看记录：数据异常');
        return;
      }
      // 触发兑奖记录对话框
      this.$emit('toLotteryRecord', row);
    },
    handleCopy: function () {
      var _handleCopy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!row || !row.id)) {
                _context3.next = 1;
                break;
              }
              this.$message.warning('无法复制：数据异常');
              return _context3.abrupt("return");
            case 1:
              this.$confirm('确定要一键复制此抽奖活动吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var response, _t2;
                return regeneratorRuntime.wrap(function (_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      _context2.next = 1;
                      return (0, _lottery.copyLottery)(row.id);
                    case 1:
                      response = _context2.sent;
                      if (response.code === 200) {
                        _this.$message.success('复制成功');
                        _this.fetchData();
                      } else {
                        _this.$message.error(response.message || '复制失败');
                      }
                      _context2.next = 3;
                      break;
                    case 2:
                      _context2.prev = 2;
                      _t2 = _context2["catch"](0);
                      _this.$message.error('复制失败：' + _t2.message);
                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[0, 2]]);
              }))).catch(function () {});
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleCopy(_x) {
        return _handleCopy.apply(this, arguments);
      }
      return handleCopy;
    }(),
    handleQrcode: function () {
      var _handleQrcode = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!row || !row.id)) {
                _context4.next = 1;
                break;
              }
              this.$message.warning('无法生成二维码：数据异常');
              return _context4.abrupt("return");
            case 1:
              this.currentLottery = row;

              // 抽奖活动页点餐端、社区端均展示
              this.qrItems = [{
                label: '点餐端',
                url: "".concat(process.env.VUE_APP_ACTIVITY_URL, "/award/").concat(row.id)
              }, {
                label: '社区端',
                url: "".concat(process.env.VUE_APP_COMMUNITY_URL, "/award/").concat(row.id)
              }];
              this.qrTitle = row.title || '抽奖活动';
              this.qrcodeDialogVisible = true;
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleQrcode(_x2) {
        return _handleQrcode.apply(this, arguments);
      }
      return handleQrcode;
    }(),
    handleDelete: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.$confirm('确认删除该抽奖活动吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var response, _t3;
                return regeneratorRuntime.wrap(function (_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.prev = 0;
                      _context5.next = 1;
                      return (0, _lottery.deleteLottery)(row.id);
                    case 1:
                      response = _context5.sent;
                      if (response.code === 200) {
                        _this2.$message.success('删除成功');
                        _this2.fetchData();
                      } else {
                        _this2.$message.error(response.message || '删除失败');
                      }
                      _context5.next = 3;
                      break;
                    case 2:
                      _context5.prev = 2;
                      _t3 = _context5["catch"](0);
                      _this2.$message.error('删除失败：' + _t3.message);
                    case 3:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5, null, [[0, 2]]);
              }))).catch(function () {});
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleDelete(_x3) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }(),
    handleStatusChange: function () {
      var _handleStatusChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(row) {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 1;
              return (0, _lottery.toggleLotteryStatus)(row.id);
            case 1:
              response = _context7.sent;
              if (response.code === 200) {
                this.$message.success('状态更新成功');
                this.fetchData();
              } else {
                row.enabled = row.enabled === 1 ? 0 : 1;
                this.$message.error(response.message || '状态更新失败');
              }
              _context7.next = 3;
              break;
            case 2:
              _context7.prev = 2;
              _t4 = _context7["catch"](0);
              row.enabled = row.enabled === 1 ? 0 : 1;
              this.$message.error('状态更新失败：' + _t4.message);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function handleStatusChange(_x4) {
        return _handleStatusChange.apply(this, arguments);
      }
      return handleStatusChange;
    }(),
    formatTime: function formatTime(time) {
      if (!time) return '-';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    }
  }
};